import React from "react";
import moment from "moment";

import { Document, Page, Text, View, Image } from "@react-pdf/renderer";
import { styles } from "./index.styles";
import {
  AMANAT_BUSINESS_ID,
  DWP_BUSINESS_ID,
  DWP_STAGING_BUSINESS_ID,
  AMANAT_STAGING_BUSINESS_ID,
} from "utils/constants";
import {
  OrderListingResponseResult,
  OrderListingResponseOrderDetail,
} from "utils/types";
import { validateDateTimeFormat } from "features/components/helperFunctions";

import { SlipsProps } from "../index.types";

let logoUrl: any = "";

const PackingSlip = ({
  packingSlipData,
  pdfType,
  totalWeight,
  listCategories,
  branchesAccessDetails,
}: SlipsProps) => {
  const { eatout_name, eatout_id, eatout_logo } = JSON.parse(
    localStorage.getItem("businessInfo")!
  );
  const { businessEmail, businessPhoneNo, currency } = JSON.parse(
    localStorage.getItem("ts-global")!
  );
  function removeQuotes(str: string) {
    if (str.startsWith('"') && str.endsWith('"')) {
      return str.substring(1, str.length - 1);
    } else {
      return str;
    }
  }

  // get height based on text length
  const getDynamicHeight = (note: string, comment: string) => {
    let boxHeight = "";
    if (comment && !note) {
      if (comment.length <= 42) {
        // 1
        boxHeight = "100";
      } else if (comment.length >= 39 && comment.length <= 88) {
        // 2
        boxHeight = "120";
      } else if (comment.length >= 80 && comment.length <= 136) {
        // 3
        boxHeight = "130";
      } else if (comment.length >= 125 && comment.length <= 179) {
        // 4
        boxHeight = "140";
      } else if (comment.length >= 179 && comment.length <= 200) {
        // 5
        boxHeight = "150";
      } else if (comment.length > 200) {
        boxHeight = "175";
      }
    } else if (note && !comment) {
      if (note.length <= 42) {
        // 1
        boxHeight = "90";
      } else if (note.length >= 39 && note.length <= 88) {
        // 2
        boxHeight = "120";
      } else if (note.length >= 80 && note.length <= 136) {
        // 3
        boxHeight = "130";
      } else if (note.length >= 125 && note.length <= 179) {
        // 4
        boxHeight = "140";
      } else if (note.length >= 179 && note.length <= 200) {
        // 5
        boxHeight = "150";
      } else if (note.length > 200) {
        boxHeight = "175";
      }
    } else if (note && comment) {
      if (note.length <= 42 || comment.length <= 42) {
        // 1
        boxHeight = "150";
      } else if (
        (note.length >= 39 && note.length <= 88) ||
        (comment.length >= 39 && comment.length <= 88)
      ) {
        // 2
        boxHeight = "120";
      } else if (
        (note.length >= 80 && note.length <= 136) ||
        (comment.length >= 80 && comment.length <= 136)
      ) {
        // 3
        boxHeight = "130";
      } else if (
        (note.length >= 125 && note.length <= 179) ||
        (comment.length >= 125 && comment.length <= 179)
      ) {
        // 4
        boxHeight = "140";
      } else if (
        (note.length >= 179 && note.length <= 200) ||
        (comment.length >= 179 && comment.length <= 200)
      ) {
        // 5
        boxHeight = "150";
      } else if (note.length > 200 || comment.length > 200) {
        boxHeight = "175";
      }
    } else {
      boxHeight = "95";
    }
    return boxHeight;
  };

  const getBranchDetails = (eatout_bid: string) => {
    return branchesAccessDetails?.find(
      (branch) => branch.branch_id === eatout_bid
    );
  };

  function replaceLogoUrl(originalUrl: string, replacement: string) {
    const regex = /^(.*\/)(?=logos\/)/;
    return originalUrl.replace(regex, replacement);
  }

  if (eatout_logo) {
    const s3Live = "https://tossdown-images-live.s3.amazonaws.com/";
    const s3Staging = "https://tossdown-images.s3.us-east-2.amazonaws.com/";

    if (eatout_logo.includes("beta")) {
      logoUrl = replaceLogoUrl(eatout_logo, s3Staging);
    } else {
      logoUrl = replaceLogoUrl(eatout_logo, s3Live);
    }
  }

  return (
    <>
      <Document>
        {packingSlipData ? (
          packingSlipData?.map(
            (selectedOrder: OrderListingResponseResult, index: number) => {
              const {
                status,
                order_id,
                name,
                date,
                mobile_number,
                user_email,
                landline_number,
                note,
                pickup_time,
                address,
                order_detail,
                total_qty,
                tax_type,
                delivery_charges,
                tax_value,
                tip,
                service_charges,
                grand_total,
                statuscomment,
                order_type: orderType,
                order_type_flag: orderTypeFlag,
                delivery_date,
                payment_type,
                total, //Order Total
                custom_code_type,
                custom_code_discount_value,
                discount_value,
                cnic,
                pre_auth,
                eatout_bid,
                eatout_address,
                eatout_location,
              } = selectedOrder;

              return (
                <Page size="A4" style={styles.page} key={index} wrap>
                  {/* new design for order invoice now */}
                  <View style={styles.spaceBetweenRow}>
                    {/* 1 */}
                    <View style={styles.businessInfoStyles}>
                      <View style={styles.logoContainer}>
                        <View style={styles.logoCss}>
                          <Image src={logoUrl} />
                        </View>
                      </View>
                      <View style={styles.sellerDetailBox}>
                        <View style={styles.sellerDetails}>
                          <Text style={styles.sellerHeading}>
                            {eatout_name}
                          </Text>
                          <Text style={styles.sellerEmailNumberAddress}>
                            {getBranchDetails(eatout_bid)?.email
                              ? getBranchDetails(eatout_bid)?.email
                              : businessEmail && JSON.parse(businessEmail)}
                          </Text>
                          <Text style={styles.sellerEmailNumberAddress}>
                            {getBranchDetails(eatout_bid)?.phone
                              ? getBranchDetails(eatout_bid)?.phone
                              : businessPhoneNo && JSON.parse(businessPhoneNo)}
                          </Text>
                          <Text style={styles.sellerEmailNumberAddress}>
                            {" "}
                            {`${eatout_address}, ${eatout_location}`}{" "}
                          </Text>
                        </View>
                      </View>
                    </View>

                    {/* 3 */}
                    <View style={styles.userInfoStyles}>
                      <View style={styles.billingBox}>
                        <View style={styles.headAddress}>
                          <Text style={styles.customerDetailsHeading}>
                            Billed to
                          </Text>
                        </View>
                        <View style={styles.headAddress}>
                          <Text style={styles.customerDetailsText}>{name}</Text>
                        </View>

                        <View style={styles.headAddress}>
                          <Text style={styles.customerDetailsText}>
                            {mobile_number}
                          </Text>
                        </View>

                        <View style={styles.headAddress}>
                          <Text style={styles.customerDetailsText}>
                            {user_email}
                          </Text>
                        </View>

                        <View style={styles.headAddress}>
                          <Text style={styles.customerDetailsText}>
                            {address}
                          </Text>
                        </View>

                        {statuscomment !== "" && (
                          <Text style={styles.commentAndNote}>
                            <Text style={styles.noteHeading}>
                              Status Comment:
                            </Text>
                            <Text style={styles.customerDetailsNote}>
                              &nbsp; {statuscomment}
                            </Text>
                          </Text>
                        )}

                        {note !== "" && (
                          <Text style={styles.commentAndNote}>
                            <Text style={styles.noteHeading}>Note:</Text>
                            <Text style={styles.customerDetailsNote}>
                              &nbsp; {note}
                            </Text>
                          </Text>
                        )}

                        {landline_number !== "" && (
                          <Text style={styles.commentAndNote}>
                            <Text style={styles.noteHeading}>Staff note:</Text>
                            <Text style={styles.customerDetailsNote}>
                              &nbsp; {landline_number}
                            </Text>
                          </Text>
                        )}
                      </View>
                    </View>
                  </View>

                  {pdfType !== "pdf" && (
                    <View>
                      <Text style={styles.packingSlip}>
                        {listCategories ? "PICKUP SLIP" : "PACKING SLIP"}
                      </Text>
                    </View>
                  )}

                  <View>
                    <View style={styles.headerDivider}></View>

                    <View style={styles.orderDetailHeader}>
                      {/* 1 */}
                      <View style={styles.cardSectionCSS}>
                        <Text style={styles.middleSectionHeadings}>
                          Order #
                        </Text>

                        <Text style={styles.middleSectionValues}>
                          {order_id}
                        </Text>
                      </View>

                      {/* 2 */}
                      <View style={styles.cardSectionCSS}>
                        <Text style={styles.middleSectionHeadings}>
                          Order Type
                        </Text>

                        <Text style={styles.middleSectionValues}>
                          {orderType &&
                            `${orderType
                              .charAt(0)
                              .toUpperCase()}${orderType.slice(1)}`}
                        </Text>
                      </View>

                      {/* 3 */}
                      <View style={styles.cardSectionCSS}>
                        <Text style={styles.middleSectionHeadings}>
                          Order Placed
                        </Text>

                        <Text style={styles.middleSectionValues}>
                          {moment(date).format("MMM Do, YY hh:mm a")}
                        </Text>
                      </View>

                      {/* 4 - Delivery Date and time */}
                      {orderTypeFlag === "0" &&
                        delivery_date &&
                        delivery_date !== "0000-00-00 00:00:00" && (
                          <View style={styles.cardSectionCSS}>
                            <Text style={styles.middleSectionHeadings}>
                              Delivery Date & Time
                            </Text>

                            <Text style={styles.middleSectionValues}>
                              {validateDateTimeFormat(delivery_date)}
                            </Text>
                          </View>
                        )}

                      {/* 5 */}
                      <View style={styles.cardSectionCSS}>
                        <Text style={styles.middleSectionHeadings}>
                          Payment Mode
                        </Text>

                        <Text style={styles.middleSectionValues}>
                          {payment_type}
                        </Text>
                      </View>

                      {/* 6 */}
                      <View style={styles.cardSectionCSS}>
                        <Text style={styles.middleSectionHeadings}>Status</Text>

                        <Text style={styles.middleSectionValues}>
                          {/* for delivery (0) & for pickup (1) */}
                          {status === "Pending" &&
                          orderTypeFlag === "0" &&
                          pre_auth == "1"
                            ? `${status + " - " + "Authorized"}`
                            : status === "Cancel"
                            ? "Cancelled"
                            : status}
                        </Text>
                      </View>
                    </View>

                    <View style={styles.headerDivider}></View>
                  </View>

                  {/* table starting */}
                  {pdfType === "pdf" ? (
                    <View style={styles.paddingPackingSlip}>
                      <View style={styles.tableHeadOrdersPdf}>
                        <View style={styles.packingSlipFlexEndNO}>
                          <Text style={styles.textth2}>#</Text>
                        </View>
                        {listCategories && (
                          <View style={{ ...styles.flexStartCategory }}>
                            <Text style={styles.textth2}>Category </Text>
                          </View>
                        )}
                        <View style={styles.packingSlipFlexStartItem}>
                          <Text style={styles.textth2}>Item Name</Text>
                        </View>

                        <View style={styles.packingSlipFlexStartBrand}>
                          <Text style={styles.textth2}>Brand</Text>
                        </View>

                        <View style={styles.packingSlipFlexEnd}>
                          <Text style={styles.textth2}>
                            {eatout_id === DWP_STAGING_BUSINESS_ID ||
                            eatout_id === DWP_BUSINESS_ID
                              ? "MRP"
                              : "Price"}
                          </Text>
                        </View>

                        <View style={styles.packingSlipFlexQuantity}>
                          <Text style={styles.textth2}>Quantity</Text>
                        </View>

                        {totalWeight !== 0 && (
                          <View style={styles.packingSlipFlexEndWeight}>
                            <Text style={styles.textth2}>Weight</Text>
                          </View>
                        )}

                        <View style={styles.packingSlipAmount}>
                          <Text style={styles.textth2}>Amount</Text>
                        </View>

                        <View style={styles.packingSlipFlexEnd}>
                          <Text style={styles.textth2}>Total</Text>
                        </View>
                      </View>

                      <View style={styles.tableBox}>
                        {order_detail.map(
                          (
                            orderDetail: OrderListingResponseOrderDetail,
                            i: number
                          ) => {
                            let row = orderDetail;
                            let options: any = {};
                            const optionSets: any = [];
                            let count = 0;
                            let innerOptionsName = "";
                            if (
                              row.options &&
                              row.options !== "[]" &&
                              row.options !== "{}" &&
                              Object.keys(row.options).length !== 0
                            ) {
                              options = JSON.parse(row.options);
                              if (typeof options === "string") {
                                options = JSON.parse(options);
                              }

                              for (const key in options) {
                                options[key].map((opt: any) => {
                                  innerOptionsName = "";
                                  let haveInnerOpt =
                                    opt.inner_options !== "" ? true : false;
                                  optionSets.push({
                                    name: opt.name,
                                    quantity: opt.quantity,
                                    price: opt.price,
                                    weight: opt.weight,
                                    haveInnerOptions: haveInnerOpt,
                                  });
                                  let inner_options = opt.inner_options;
                                  if (inner_options !== "") {
                                    for (const innerKey in inner_options) {
                                      inner_options[innerKey].map(
                                        (innerOpt: any) => {
                                          innerOptionsName = `${innerOptionsName}${innerOpt.name},`;
                                        }
                                      );
                                    }
                                  }
                                  optionSets[count].inner_options =
                                    innerOptionsName;
                                  count++;
                                });
                              }
                            }

                            return (
                              <React.Fragment key={i}>
                                <View
                                  style={styles.ordersTableContent}
                                  wrap={false}
                                  key={index}
                                >
                                  <View style={styles.packingSlipFlexEndNO}>
                                    <Text style={styles.texttPdfItem}>
                                      {i + 1}
                                    </Text>
                                  </View>

                                  <View style={styles.packingSlipFlexStartItem}>
                                    <Text style={styles.texttPdf}>
                                      {`${orderDetail.item_name}`}
                                    </Text>
                                    {(eatout_id == DWP_STAGING_BUSINESS_ID ||
                                      eatout_id == DWP_BUSINESS_ID ||
                                      eatout_id == AMANAT_BUSINESS_ID ||
                                      eatout_id ==
                                        AMANAT_STAGING_BUSINESS_ID) && (
                                      <Text style={styles.texttcomPdf}>
                                        SKU:{orderDetail.product_code}
                                      </Text>
                                    )}
                                    {optionSets.map(
                                      (f: any, optionIndex: number) =>
                                        f.haveInnerOptions ? (
                                          <Text
                                            style={styles.textDonePdf}
                                            key={optionIndex}
                                          >
                                            -
                                            {`${f.name}${
                                              parseFloat(f.price)
                                                .toFixed(2)
                                                .toString() === "0.00"
                                                ? ""
                                                : `, Qty: ${f.quantity}, Price: ${f.price}`
                                            } ${
                                              f.inner_options === ""
                                                ? ""
                                                : `(${f.inner_options})`
                                            }`}
                                          </Text>
                                        ) : (
                                          <Text style={styles.textDonePdf}>
                                            -
                                            {`${f.name}${
                                              parseFloat(f.price)
                                                .toFixed(2)
                                                .toString() === "0.00"
                                                ? ""
                                                : `, Qty: ${f.quantity}, Price: ${f.price}`
                                            }`}
                                          </Text>
                                        )
                                    )}
                                    <Text style={styles.texttcom}>
                                      {`${orderDetail.comment}`}
                                    </Text>
                                  </View>

                                  <View
                                    style={styles.packingSlipFlexStartBrand}
                                  >
                                    <Text style={styles.texttPdfBrand}>
                                      {orderDetail.brand_name}
                                    </Text>
                                  </View>

                                  <View style={styles.packingSlipFlexEnd}>
                                    <Text style={styles.texttPdf}>
                                      {orderDetail.price}
                                    </Text>
                                  </View>

                                  <View style={styles.packingSlipFlexQuantity}>
                                    <Text style={styles.texttPdf}>
                                      {orderDetail.quantity}
                                    </Text>
                                  </View>

                                  {totalWeight !== 0 && (
                                    <View
                                      style={styles.packingSlipFlexEndWeight}
                                    >
                                      <Text
                                        style={styles.texttPdf}
                                      >{`${orderDetail.weight_value} ${orderDetail.weight_unit}`}</Text>
                                    </View>
                                  )}

                                  <View style={styles.packingSlipAmount}>
                                    <Text style={styles.texttPdf}>
                                      {orderDetail.total}
                                    </Text>
                                  </View>

                                  <View style={styles.packingSlipFlexEnd}>
                                    <Text style={styles.texttPdf}>
                                      {orderDetail.item_level_grand_total}
                                    </Text>
                                  </View>
                                </View>
                              </React.Fragment>
                            );
                          }
                        )}
                      </View>
                    </View>
                  ) : (
                    <View style={styles.paddingPackingSlip}>
                      <View style={styles.tableHeadOrdersPdf}>
                        <View style={styles.packingSlipFlexEndNO}>
                          <Text style={styles.textth2}>#</Text>
                        </View>
                        {listCategories && (
                          <View style={styles.flexStartCategory}>
                            <Text style={styles.textth2}>Category </Text>
                          </View>
                        )}
                        <View
                          style={{
                            ...styles.flexStartItem,
                            width: listCategories ? "45%" : "58%",
                          }}
                        >
                          <Text style={styles.textth2}>Item Name</Text>
                        </View>
                        <View style={styles.flexStartBrand}>
                          <Text style={styles.textth2}>Brand</Text>
                        </View>
                        <View style={styles.flexQuantity}>
                          <Text style={styles.textth2}>Quantity</Text>
                        </View>
                      </View>

                      <View style={styles.tableBox}>
                        {order_detail.map(
                          (
                            orderDetail: OrderListingResponseOrderDetail,
                            i: number
                          ) => {
                            let row = orderDetail;
                            let options: any = {};
                            const optionSets: any = [];
                            let count = 0;
                            let innerOptionsName = "";
                            if (
                              row.options &&
                              row.options !== "[]" &&
                              row.options !== "{}" &&
                              Object.keys(row.options).length !== 0
                            ) {
                              options = JSON.parse(row.options);
                              if (typeof options === "string") {
                                options = JSON.parse(options);
                              }

                              for (const key in options) {
                                options[key].map((opt: any) => {
                                  innerOptionsName = "";
                                  let haveInnerOpt =
                                    opt.inner_options !== "" ? true : false;
                                  optionSets.push({
                                    name: opt.name,
                                    quantity: opt.quantity,
                                    price: opt.price,
                                    weight: opt.weight,
                                    haveInnerOptions: haveInnerOpt,
                                  });
                                  let inner_options = opt.inner_options;
                                  if (inner_options !== "") {
                                    for (const innerKey in inner_options) {
                                      inner_options[innerKey].map(
                                        (innerOpt: any) => {
                                          innerOptionsName = `${innerOptionsName}${innerOpt.name},`;
                                        }
                                      );
                                    }
                                  }
                                  optionSets[count].inner_options =
                                    innerOptionsName;
                                  count++;
                                });
                              }
                            }
                            return (
                              <React.Fragment key={i}>
                                <View
                                  style={styles.ordersTableContent}
                                  wrap={false}
                                  key={index}
                                >
                                  <View style={styles.packingSlipFlexEndNO}>
                                    <Text style={styles.texttPdfItem}>
                                      {i + 1}
                                    </Text>
                                  </View>
                                  {listCategories && (
                                    <View style={styles.flexStartCategory}>
                                      <Text style={styles.texttPdfItem}>
                                        {`${orderDetail.item_cat_name}`}
                                      </Text>
                                    </View>
                                  )}
                                  <View
                                    style={{
                                      ...styles.flexStartItem,
                                      width: listCategories ? "45%" : "58%",
                                    }}
                                  >
                                    <Text style={styles.texttPdf}>
                                      {`${orderDetail.item_name}`}
                                    </Text>

                                    {(eatout_id == DWP_STAGING_BUSINESS_ID ||
                                      eatout_id == DWP_BUSINESS_ID ||
                                      eatout_id == AMANAT_BUSINESS_ID ||
                                      eatout_id ==
                                        AMANAT_STAGING_BUSINESS_ID) && (
                                      <Text style={styles.texttcomPdf}>
                                        SKU:{orderDetail.product_code}
                                      </Text>
                                    )}

                                    {optionSets.map(
                                      (f: any, optionIndex: number) =>
                                        f.haveInnerOptions ? (
                                          <Text
                                            style={styles.textDonePdf}
                                            key={optionIndex}
                                          >
                                            -
                                            {`${f.name}${
                                              parseFloat(f.price)
                                                .toFixed(2)
                                                .toString() === "0.00"
                                                ? ""
                                                : `, Qty: ${f.quantity}, Price: ${f.price}`
                                            } ${
                                              f.inner_options === ""
                                                ? ""
                                                : `(${f.inner_options})`
                                            }`}
                                          </Text>
                                        ) : (
                                          <Text style={styles.textDonePdf}>
                                            -
                                            {`${f.name}${
                                              parseFloat(f.price)
                                                .toFixed(2)
                                                .toString() === "0.00"
                                                ? ""
                                                : `, Qty: ${f.quantity}, Price: ${f.price}`
                                            }`}
                                          </Text>
                                        )
                                    )}
                                    <Text style={styles.texttcom}>
                                      {`${orderDetail.comment}`}
                                    </Text>
                                  </View>

                                  <View style={styles.flexStartBrand}>
                                    <Text style={styles.texttPdfBrand}>
                                      {orderDetail.brand_name}
                                    </Text>
                                  </View>

                                  <View style={styles.flexQuantity}>
                                    <Text style={styles.texttPdf}>
                                      {orderDetail.quantity}
                                    </Text>
                                  </View>
                                </View>
                              </React.Fragment>
                            );
                          }
                        )}
                      </View>
                    </View>
                  )}

                  <View style={styles.calculationSectionStyles} wrap={false}>
                    <View
                      style={
                        pdfType === "pdf"
                          ? styles.currencyRow2Pdf
                          : styles.currencyrow2
                      }
                    ></View>

                    <View style={styles.currencyRow}>
                      {pdfType === "pdf" && (
                        <View>
                          <View style={styles.rowend}>
                            <View style={styles.currencyrow}>
                              <Text style={styles.texth2th}>
                                Total Quantity
                              </Text>
                            </View>
                            <View style={styles.currencyrow}>
                              <Text style={styles.texth2tCouponCode}>
                                {`${total_qty}`}
                              </Text>
                            </View>
                          </View>

                          <View style={styles.rowend}>
                            <View style={styles.currencyrow}>
                              <Text style={styles.texth2th}>
                                {/* showing  "Total Amount (Inclusive of Taxes)" only for DWP  */}
                                {eatout_id === DWP_STAGING_BUSINESS_ID ||
                                eatout_id === DWP_BUSINESS_ID
                                  ? "Total Amount (Inclusive of Taxes)"
                                  : "Total"}
                              </Text>
                            </View>

                            <View style={styles.currencyrow}>
                              <Text style={styles.texth2tTotal}>{total}</Text>
                            </View>
                          </View>

                          {custom_code_type === "0" && (
                            <View style={styles.rowend}>
                              <View style={styles.currencyrow}>
                                <Text style={styles.texth2th}>Coupon Code</Text>
                              </View>
                              <View style={styles.currencyrow}>
                                <Text style={styles.texth2tCouponCode}>
                                  {custom_code_discount_value}
                                </Text>
                              </View>
                            </View>
                          )}

                          {discount_value !== "0.00" && (
                            <View style={styles.rowend}>
                              <View style={styles.currencyrow}>
                                <Text style={styles.texth2th}>Discount</Text>
                              </View>
                              <View style={styles.currencyrow}>
                                <Text style={styles.texth2tDiscount}>
                                  {discount_value}
                                </Text>
                              </View>
                            </View>
                          )}

                          {delivery_charges !== "0.00" && (
                            <View style={styles.rowend}>
                              <View style={styles.currencyrow}>
                                <Text style={styles.texth2th}>
                                  Delivery Charges
                                </Text>
                              </View>
                              <View style={styles.currencyrow}>
                                <Text style={styles.texth2tDeliveryCharges}>
                                  {delivery_charges}
                                </Text>
                              </View>
                            </View>
                          )}

                          {tax_value !== "0.00" && (
                            <View style={styles.rowend}>
                              <View style={styles.currencyrow}>
                                <Text style={styles.texth2th}>Tax</Text>
                              </View>
                              <View style={styles.currencyrow}>
                                <Text style={styles.textTax}>{tax_value}</Text>
                              </View>
                            </View>
                          )}

                          {service_charges !== "0.00" && (
                            <View style={styles.rowend}>
                              <View style={styles.currencyrow}>
                                <Text style={styles.texth2th}>
                                  Service Charges
                                </Text>
                              </View>
                              <View style={styles.currencyrow}>
                                <Text style={styles.texServiceCharges}>
                                  {service_charges}
                                </Text>
                              </View>
                            </View>
                          )}
                        </View>
                      )}
                    </View>
                  </View>
                  {pdfType === "pdf" && (
                    <>
                      <View style={styles.headerDivider}></View>

                      <View style={styles.businessDetailsRow}>
                        <View style={styles.currencyRowEmail}>
                          <Text style={styles.thankyouMessage}>
                            Thank you for your purchase!
                          </Text>
                        </View>

                        <View style={styles.currencyRowPhone}>
                          <Text style={styles.grandTotalLabel}>
                            Grand Total (
                          </Text>
                          <Text style={styles.currencyColor}>
                            {removeQuotes(currency)}
                          </Text>
                          <Text style={styles.grandTotalLabel}>)</Text>
                          <Text style={styles.grandTotalValue}>
                            {grand_total}
                          </Text>
                        </View>
                      </View>
                    </>
                  )}
                </Page>
              );
            }
          )
        ) : (
          <View> Loading</View>
        )}
      </Document>
    </>
  );
};
export default PackingSlip;
